/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TeamPublic } from './TeamPublic';
import {
    TeamPublicFromJSON,
    TeamPublicFromJSONTyped,
    TeamPublicToJSON,
} from './TeamPublic';

/**
 * 
 * @export
 * @interface PaginatedTeamPublicList
 */
export interface PaginatedTeamPublicList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTeamPublicList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTeamPublicList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTeamPublicList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<TeamPublic>}
     * @memberof PaginatedTeamPublicList
     */
    results?: Array<TeamPublic>;
}

/**
 * Check if a given object implements the PaginatedTeamPublicList interface.
 */
export function instanceOfPaginatedTeamPublicList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginatedTeamPublicListFromJSON(json: any): PaginatedTeamPublicList {
    return PaginatedTeamPublicListFromJSONTyped(json, false);
}

export function PaginatedTeamPublicListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedTeamPublicList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(TeamPublicFromJSON)),
    };
}

export function PaginatedTeamPublicListToJSON(value?: PaginatedTeamPublicList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(TeamPublicToJSON)),
    };
}

